function initBlend() {
   new Swiper(".blend-slider", {
      slidesPerView: "auto",
      speed: 1e3
   })
}

function initFaq() {
   document.querySelectorAll(".faq-question").forEach(function (e) {
      e.addEventListener("click", function (e) {
         e.preventDefault();
         const i = this.closest(".faq-item"),
            t = i.querySelector(".faq-answer");
         jQuery(t).slideToggle(300), i.classList.toggle("is-active")
      })
   })
}

function initHeader() {
   const e = document.querySelector(".header-menu"),
      i = document.querySelector(".header-close"),
      t = document.querySelector(".header-burger");
   t && t.addEventListener("click", () => {
      e.classList.toggle("active")
   }), i && i.addEventListener("click", () => {
      e.classList.remove("active")
   })
}

function ingredients() {
   new Swiper(".ingredients-swiper", {
      slidesPerView: "auto",
      speed: 1e3
   })
}

function initProductSubsliders() {
   const e = new Swiper(".product-subslider", {
      spaceBetween: 1,
      slidesPerView: "auto",
      freeMode: !0,
      watchSlidesProgress: !0,
      spaceBetween: 10
   });
   new Swiper(".product-slider", {
      spaceBetween: 10,
      thumbs: {
         swiper: e
      }
   })
}

function initProductAccordion() {
   document.querySelectorAll(".product-accordion-btn").forEach(function (e) {
      e.addEventListener("click", function (e) {
         e.preventDefault();
         const i = this.closest(".product-accordion-item"),
            t = i.querySelector(".product-accordion-content");
         jQuery(t).slideToggle(300), i.classList.toggle("is-active")
      })
   })
}
initBlend(), initFaq(), initHeader(), ingredients(), initProductSubsliders(), initProductAccordion(), Fancybox.bind("[data-fancybox]", {});
const storiesSlider = new Swiper(".stories-slider", {
   slidesPerView: 'auto',
        spaceBetween: 5,
        centeredSlides: true,
        speed: 1000,
        loop: true
});

function testimonialsSlider() {
   new Swiper(".testimonials-slider", {
      slidesPerView: "auto",
      speed: 1e3
   })
}
testimonialsSlider();
storiesSlider();